import * as vp from 'vopay';
import { FC, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../providers/Permissions.provider';
import { useNavMenu } from '../../../providers/NavMenu.provider';
import { useClientLogin } from '../../../providers/ClientLogin.provider';
import { useOpenModule } from '../../../providers/OpenModule.provider';

const { NavModule } = vp;

export type NavListProps = {
  onClick: () => void;
};

const NavList: FC<NavListProps> = ({ onClick }: NavListProps) => {
  const history = useHistory();
  const { reset: resetNavMenu } = useNavMenu();
  const { onNavClick } = useNavMenu();
  const { setOpenModule } = useOpenModule();
  const { logout, response, switchUser } = useClientLogin();
  const [accountListShow, setAccountListShow] = useState(false);
  const { permissions } = usePermissions();
  const [isMobile, setIsMobile] = useState(false);
  const [expandMenue, setExpandMenu] = useState(true);
  const { t } = useTranslation('translations', { keyPrefix: 'UI.UserDropDown.NavList' });

  window.addEventListener('resize', () => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  });

  useEffect(() => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  }, []);

  useEffect(() => {
    isMobile ? setExpandMenu(false) : setExpandMenu(true);
  }, [isMobile]);

  return (
    <>
      {permissions.ViewUsers && response.UserManagementEnabled === '1' && (
        <NavModule
          id="user-dropdown-user-managament"
          label={t('userManagement')}
          isActive={false}
          icon="myAccount"
          iconHeight="20px"
          activeIcon="myAccountOn"
          iconColor="primary-dark"
          variant="2"
          isOpen={false}
          expandMenu={expandMenue}
          onClick={() => {
            onClick();
            resetNavMenu();
            setOpenModule('dashboard');
            history.push('/users');
          }}
          showNavModule={() => true}
        />
      )}
      <NavModule
        id="user-dropdown-user-settings"
        label={t('userSettings')}
        isActive={false}
        icon="userSettings"
        iconHeight="22px"
        activeIcon="userSettingsOn"
        iconColor="primary-dark"
        variant="2"
        isOpen={false}
        expandMenu={expandMenue}
        onClick={() => {
          onClick();
          resetNavMenu();
          setOpenModule('dashboard');
          history.push('/users/settings');
        }}
        showNavModule={() => true}
      />
      {Object.values(response.AdditionalAccounts || {}).length > 0 && (
        <NavModule
          id="user-dropdown-switch-user"
          // _TODO: reset branding
          label={t('switchAccount')}
          isActive={false}
          icon="myAccount"
          iconHeight="20px"
          activeIcon="myAccountOn"
          iconColor="primary-dark"
          variant="2"
          isOpen={accountListShow}
          expandMenu={expandMenue}
          onClick={() => {
            resetNavMenu();
            setOpenModule('dashboard');
            setAccountListShow(!accountListShow);
          }}
          subNavModules={Object.entries(response.AdditionalAccounts || {})
            .map((account) => {
              const name = account[0];
              const jwt = account[1];
              const showNav = response.AccountName === name;
              return {
                id: `user-dropdown-switch-user-${name}`,
                label: name,
                isActive: false,
                isOpen: false,
                showNavModule: () => !showNav,
                variant: '2' as const,
                isLocked: () => false,
                onClick: () => {
                  onClick();
                  resetNavMenu();
                  setOpenModule('dashboard');
                  setAccountListShow(false);
                  switchUser({
                    JWToken: jwt,
                  });
                },
              };
            })
            .filter((x) => x.showNavModule())}
          showNavModule={() => true}
        />
      )}
      <NavModule
        id="user-dropdown-change-password"
        label={t('changePassword')}
        isActive={false}
        icon="lock"
        iconHeight="20px"
        activeIcon="lock2"
        iconColor="primary-dark"
        variant="2"
        isOpen={false}
        expandMenu={expandMenue}
        onClick={() => {
          onClick();
          resetNavMenu();
          setOpenModule('dashboard');
          history.push('/dashboard/user/profile');
        }}
        showNavModule={() => true}
      />
      <NavModule
        id="user-dropdown-logout"
        label={t('logOut')}
        isActive={false}
        icon="logOut"
        iconHeight="20px"
        activeIcon="logOutOn"
        iconColor="primary-dark"
        variant="2"
        isOpen={false}
        expandMenu={expandMenue}
        onClick={() => {
          onNavClick('dashboard');
          setOpenModule('dashboard');
          logout();
        }}
        showNavModule={() => true}
      />
    </>
  );
};

export default NavList;
